var _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuMobileClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 7,
    fill: "#091026"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 33.5061,
    width: 29,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(-45 13 33.5061)",
    fill: "url(#paint0_linear_1677_4755)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1309,
    y: 13.113,
    width: 29,
    height: 2.5,
    rx: 1.25,
    transform: "rotate(45 15.1309 13.113)",
    fill: "url(#paint1_linear_1677_4755)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1677_4755",
    x1: 42,
    y1: 33.5061,
    x2: 13,
    y2: 33.5061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7D61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1677_4755",
    x1: 44.1309,
    y1: 13.113,
    x2: 15.1309,
    y2: 13.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7D61"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuMobileClose);
export default __webpack_public_path__ + "static/media/icon_menu_mobile_close.864a06795dcc07c4c4df7e65310f2b70.svg";
export { ForwardRef as ReactComponent };